import { OrderBook, OrderStatus } from "./orderInterfaces";
import { StepInstrumentType, StepOrderSide } from "./stepInterfaces";
import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface IMarketmakingTaskSearchParam extends ISearchParameters {
  baseInsId: string;
  justActive: boolean;
}

export interface IMarketmakingTaskTableReport extends ITableReport {
  username: string;
  userId: number;
  applicationUsername: string;
  volatility: number;
  snapshot_FairPrice: number;
  snapshot_BasePrice: number;
  threshold: number;
  lastSnapshotTime: string;
  lastSnapshotStr: string;
  isActive: boolean;
  optionName: string;
  optionId: number;
  baseInsFactor: number;
}

export interface IAddEditMarketmakingTask {
  id?: number;
  insId: number;
  accountId: string;
  volatility: number;
  threshold: number;
  baseInsFactor: number;
}

export interface IOpenOrder {
  side: StepOrderSide;
  orderSide?: StepOrderSide;
  price: number;
  volume: number;
  row?: number;
}

export interface IMarketmakingOrderbookPairResp {
  fullOrderBook: OrderBook;
  baseInsPriceLive: number;
  baseInsPriceSnapshot: number;
  liveToSnapshotChangeRatio: number;
  liveFairPrice: number;
  openOrders: IOpenOrder[];
}

export interface IMarketmakingInstruments {
  baseId: number;
  baseName: string; //ui only
  refOption1: string;
  refOption2: string;
  aTMFactor: string;
  iTMFactor: string;
  oTMFactor: string;
  ivInf: string;
  remainingDays: number;
}

export interface IMarketmakingConfig {
  riskFreeRate: number;
  instruments: IMarketmakingInstruments[];
}

export enum MarketmakingTableTabs {
  OrderTable = 1,
  TradeTable,
  ErrorsTable,
  Program,
}

export interface IMarketmakingTradeTableSearchParams extends ISearchParameters {
  taskId?: number;
  accountId?: number;
  optionInstrumentId?: string;
}

export interface IMarketmakingOrderTableSearchParams extends ISearchParameters {
  taskId?: number;
}

export interface IMarketmakingOrderTableReport extends ITableReport {
  orderSide: StepOrderSide;
  orderSideClassname: string;
  sahraName: string;
  operator: string;
  namad: string;
  optionType: string;
  totalSize: number;
  firstStep: number;
  lastStep: number;
  stepCount: number;
  doneStepCount: number;
  filledVolume: number;
  errorCount: number;
  date: string;
  instrumentType: StepInstrumentType;
  instrument: string;
  baseInstrument: string;
  optionInstrument: string;
  orderStatus: OrderStatus;
  isActive: true;
  userId: number;
}

export interface IMarketmakingTradeTableReport extends ITableReport {}

export interface IMarketmakingProgram {
  buy: IMarketingProgramRowItem[];
  sell: IMarketingProgramRowItem[];
}

export interface IMarketingProgramRowItem {
  no: number;
  from: string;
  to: string;
  flexibilityPercent: number;
  flexibilityAmount: number;
}

export interface IMarketmakingTriggerTableReport extends ITableReport {}

export interface IMarketmakingSetProgramBody extends IMarketmakingProgram {
  taskId: number;
}

export interface IMarketmakingPredefinedProgram extends IMarketmakingProgram {
  id?: number;
  programName: string;
}

export interface IPreviewOffer {
  fromVolume: number;
  toVolume: number;
  calculatedPrice: number;
}

export interface IGetPreviewOfferResp {
  buy: IPreviewOffer[];
  sell: IPreviewOffer[];
  taskId: number;
}
